import loadAuthenticationModule from './modules/Authentication.module';
import loadSessionModule from './modules/Session.module';
import loadBasketModule from './modules/Basket.module';
import loadWishListModule from './modules/WishList.module';
import loadCheckoutModule from './modules/Checkout.module';
const loadCheckoutRootModule = () => ({
    hasRouter: true,
    modules: [
        loadSessionModule(),
        loadAuthenticationModule(),
        loadBasketModule(),
        loadWishListModule(),
        loadCheckoutModule(),
    ],
});
export default loadCheckoutRootModule;
